// vars not based on pageload

var navBreakpoint = 920,
    mobileBreakpoint = 600,
    isIE9 = isIE9 || false;

$( document ).ready(function() {
  $(".focuspoint").focusPoint();

  function toggleMobileNav() {
    $('.nav-drop__primary, .nav-drop__secondary, .nav-drop__tertiary').removeClass("nav-drop--open");
    if ($('.nav-bar').hasClass('mobile-nav-open')) {
      $('.nav-bar').removeClass('mobile-nav-open');
      enableBodyScroll();
    } else {
      $('.nav-bar').addClass('mobile-nav-open');
      disableBodyScroll();
    }
  }

  function concealCookieBanner() {
    // Select the node that will be observed for mutations
    var targetNode = document.querySelector('.footer');

    // Options for the observer (which mutations to observe)
    var config = { attributes: true, childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    function callback(mutationsList, observer) {
      $('.optanon-show-settings-popup-wrapper').removeClass('optanon-show-settings-popup-wrapper');
      observer.disconnect()
    }

    // Create an observer instance linked to the callback function
    var observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
  }

  concealCookieBanner();

  // vars based on pageload

  var ww = $(window).width();

  $(window).resize(function() {
    var ww=$(window).width();
    resizeContrastIconWidths();
    updateFillerDiv();
    clearBlogImages();
    if (chatIsOpen($('#chatBox'))) {
      attachCloseChatListener($('#chatBox'));
    };
    if (ww < mobileBreakpoint && chatIsOpen($('#chatBox'))) {
      attachCloseChatListener($('#chatBox'));
      disableBodyScroll();
    };
  });

  // toggles sidebar resources in accordions
  function toggleResource($this) {
    $this.toggleClass('open-resource');
    $this.find('.arrow_up_circle').toggle();
    $this.find('.arrow_down_circle').toggle();
    $this.siblings('.helper-text').slideToggle();
  }

  $('.button--resources').click(function(e) {
    e.preventDefault();
    if (!$(this).hasClass('open-resource')) toggleResource($('.button--resources.open-resource'));
    toggleResource($(this));
  });

  // if there are resources on page, set handler to close them if you click outside
  if ($('.resource-button-wrapper').length > 0) {
    $('body').on('click', function (e) {
      if (!$(e.target).closest('.resource-button-wrapper').length) {
        toggleResource($('.button--resources.open-resource'));
      }
    });
  }


  // toggles mobile nav on hamburger click

  function disableBodyScroll() {
    var top = $(window).scrollTop() * -1;
    $('body').css({
        overflow: 'hidden',
        position: 'fixed',
        top: top
      });
    $('.hidden-nav-gradient').hide();
  }

  function enableBodyScroll() {
    $('body').css({
        overflow: 'auto',
        position: 'static',
        top: 0
      });
    $('.hidden-nav-gradient').show();
  }

  function chatIsOpen($frame) {
    if ($frame.css('display') == 'none') return false;
    else return true;
  }

  function attachCloseChatListener($frame) {
    function listenForChatClose() {
      if (!chatIsOpen($frame)) {
        enableBodyScroll();
      } else {
        setTimeout(listenForChatClose, 30);
      }
    }
    setTimeout(listenForChatClose, 650); // wait for the iframe to fully appear
  }

  $(".open-chat").on("click", function(e) {
    e.stopImmediatePropagation();
    e.preventDefault();
    if ($(document).width() < mobileBreakpoint) disableBodyScroll();
    if ($('.nav-bar').hasClass('mobile-nav-open')) toggleMobileNav();
    var $frame = $("#chatBox");
    attachCloseChatListener($frame);
    if (window.languageCode) {
      var convertedLanguageCode = languageCode
        .replace('fr_ca', 'fr-CA')
        .replace('en_us', 'en');
      $frame.attr('src', '/chatbot-client/views/chatpane.html#' + convertedLanguageCode);
    } else {
      $frame.attr('src', '/chatbot-client/views/chatpane.html');
    }
    if ($frame.css("display") == "none") {
      $frame.show();
      TweenMax.fromTo($frame, 0.6, {"bottom": "-100%"}, {"bottom": "0"});
    }
    return false;
  })

  // replace all ℠ with a formatted <sup>SM</sup> since it's not included in the font.

  if (!String.prototype.includes) {
    String.prototype.includes = function(search, start) {
      'use strict';
      if (typeof start !== 'number') {
        start = 0;
      }

      if (start + search.length > this.length) {
        return false;
      } else {
        return this.indexOf(search, start) !== -1;
      }
    };
  }

  $("*:contains('℠')").contents().each(function() {
      if(this.nodeType == 3 && this.nodeValue.includes('℠')) {
        var $parent = $(this).parent(),
          fontSize = parseInt($parent.css('font-size')) * (3/5),
          top = fontSize * (-2/3);
        $(this).replaceWith($(this).text().replace(/℠/g, '<sup>SM</sup>'));
        $parent.find('sup').css({
            'font-size': fontSize + 'px',
            'top': top + 'px'
          });
      }
  });

  // same for ™

  $("*:contains('™')").contents().each(function() {
      if(this.nodeType == 3 && this.nodeValue.includes('™')) {
        var $parent = $(this).parent(),
          fontSize = parseInt($parent.css('font-size')) * (3/5),
          top = fontSize * (-2/3);
        $(this).replaceWith($(this).text().replace(/™/g, '<sup>TM</sup>'));
        $parent.find('sup').css({
            'font-size': fontSize + 'px',
            'top': top + 'px'
          });
      }
  });

  // snap blog post figure width to its child image
  $('.blog-post__content').imagesLoaded().progress(function(instance, image) {
      loadedImage = $(image.img)
      loadedImage.parent().width(loadedImage.width());
    });

  // if blog text wraps around an image, clear it if the text area is too small
  function clearBlogImages() {
    var textBlockWidth = $('.blog-post__content').width(),
        figures = $('.blog-post__content figure');

    for (var i = 0; i < figures.length; i++) {
      var $fig = $(figures[i]),
          figWidth = $fig.width();
      if (figWidth / textBlockWidth > 0.75) $fig.addClass('nowrap');
      else $fig.removeClass('nowrap');
    }
  }
  clearBlogImages();

  // keep flex items in contrast block the same height/width even if they wrap to another row

  function resizeContrastIconHeights(icons) {
    icons.css({'min-height': ''});
    var largestHeight = 0;
    icons.each(function() {
      largestHeight = Math.max(largestHeight, $(this).height());
    })
      .css({'min-height': largestHeight});
  }

  function resizeContrastIconWidths() {
    $('.icon-container').each(function() {
      var icons = $(this).find('.icon-button').not('.mobile-only');
      icons.css({'max-width': ''});
      var newWidth = $(icons[0]).outerWidth();
      icons.css({'max-width': newWidth});
      resizeContrastIconHeights(icons);
    });
  }
  resizeContrastIconWidths(); // this is also called on window resize

  // if there's any whitespace underneath the footer, hide it with a div

  function updateFillerDiv() {
    $('#filler-div').height(0);
    var h = $(window).height() - $('html').height();
    if (h >= 0) {
      $('#filler-div').height(h);
    } else {
      $('#filler-div').height(0);
    }
  }
  updateFillerDiv();

	// Slideshow for the custom page builder
	var pageBuilderSlides = $.makeArray( $('.slideshow__slide') )

	if (pageBuilderSlides.length > 1) {
		function crossfade(){
		    TweenMax.to(pageBuilderSlides[0], 2.5, {autoAlpha:0})
		    TweenMax.to(pageBuilderSlides[1], 2.5, {autoAlpha:1})
		    pageBuilderSlides.push( pageBuilderSlides.shift() )
		  }

		var cycle = setInterval(crossfade,5000)
	}

  // CAT Page
  var catPage = $('#cat-page');

  if (catPage.length != 0) {
    // Dropdown
    $('.dropdown > strong').on('click', function () {
      var $parentDropdown = $(this).parent();
      $parentDropdown.toggleClass('open');
    });

    // Tabs
    function addTabActiveClass($tab, $container) {
      $tab.addClass('active');
      $container.addClass('active');
    }

    function removeActiveClass() {
      var $activeTab = $('.tabs button.active');
      var $activeContainer = $('.tab-container.active');

      $activeTab.removeClass('active');
      $activeContainer.removeClass('active');
    }

    var $tabs = $('.tabs button');

    $tabs.on('click', function() {
      var index = $(this).index() + 1;
      var $tabContainer = $('.tab-component .tab-container:nth-child(' + index + ')');

      removeActiveClass();
      addTabActiveClass($(this), $tabContainer);
    });
  }
});



// blog comments, from https://github.com/verbb/comments/blob/craft-2/examples/ajax/ajax.html

$(document).ready(function() {
    $(document).on('submit', '.comment-form', function(e) {
        e.preventDefault();
        var $form = $(this);
        var data = $form.serialize();
        $.ajax({
            method: 'POST',
            url: data.action,
            data: data,
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
            success: function(data) {
              console.log('success', data);
              // Clear out the text box
              $form.find('textarea[name="fields[comment]"]').val('');
              // Add the new comment html
              var $comment_html = $(data.html).find('.comment-single');
              // Are we replying to a comment, or on the top-level? Determines where to append
              if (data.comment.parentId) {
                  var $replies_container = $('#comment-' + data.comment.parentId + ' .comments-list');
                  // Hide the reply form
                  $form.hide();
                  // Check for existing container for other replies
                  if ($replies_container.length == 0) {
                      $('#comment-' + data.comment.parentId).append('<ul class="comments-list"/>');
                  }
                  $('#comment-' + data.comment.parentId + ' .comments-list').append($comment_html);
              } else {
                  $('.comments-list:first').append($comment_html);
              }
            },
            error: function(data) {
              console.log('error', data);
            }
        });
    });
    // Toggle to show/hide replies
    $(document).on('click', 'a.comment-toggle', function(e) {
        e.preventDefault();
        $(this).parents('.comment-single:first').find('.comments-list:first').toggle();
    });
    // Toggle to show/hide reply form
    $(document).on('click', 'a.comment-reply', function(e) {
        e.preventDefault();
        $(this).parents('.comment-single:first').find('.comment-form:first').toggle();
    });
    // Handle voting
    $(document).on('click', 'a.comment-vote-down, a.comment-vote-up', function(e) {
        e.preventDefault();
        $.ajax({
            url: $(this).attr('href'),
            success: function(data) {
                console.log('success', data);
                // update label
                if (data.success) {
                    $(e.target).parent().parent().find('.count').html(data.votes + ' votes');
                }
            },
            error: function(data) {
                console.log('error', data);
            }
        });
    });
    // Handle flagging
    $(document).on('click', 'a.comment-flag', function(e) {
        e.preventDefault();
        $.ajax({
            url: $(this).attr('href'),
            success: function(data) {
                console.log('success', data);
                // update label
                $(e.target).parent().parent().find('.comment-flag').replaceWith('<span class="static-label comment-flag"><span class="glyphicon glyphicon-flag"></span>Flagged as inappropriate</span>');
            },
            error: function(data) {
                console.log('error', data);
            }
        });
    });
    // Handle deleting
    $(document).on('click', 'a.comment-delete', function(e) {
        e.preventDefault();
        $.ajax({
            url: $(this).attr('href'),
            success: function(data) {
                console.log('success', data);
            },
            error: function(data) {
                console.log('error', data);
            }
        });
    });
    // Handle editing
    $(document).on('click', 'a.comment-edit', function(e) {
        e.preventDefault();
        // Simply hides text and shows form
        $(this).parents('.comment-text').find('.comment-content').hide();
        $(this).parents('.comment-text').find('.edit-comment-form').show();
    });
    $(document).on('submit', '.edit-comment-form', function(e) {
        e.preventDefault();
        var data = $(this).serialize();
        var $self = $(this);
        $.ajax({
            method: 'POST',
            url: data.action,
            data: data,
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
            success: function(data) {
                console.log('success', data);
                // Update the comment text
                var comment_text = $self.find('textarea[name="fields[comment]"]').val().replace(/\n/g, '<br />');
                $self.parents('.comment-text').find('.comment-content').html('<p>'+comment_text+'</p>');
                // Hide/show form and content
                $self.parents('.comment-text').find('.comment-content').show();
                $self.parents('.comment-text').find('.edit-comment-form').hide();
            },
            error: function(data) {
                console.log('error', data);
            }
        });
    });

  // add google analytics tracking for pdfs

  $("a[href$='pdf']").each(function() { // as direct links
    $(this).on('click', function() {
      var thisHref = $(this).attr('href');
      ga('send', 'pageview', thisHref);
    })
  });

  $(".js-pdf-link").each(function() { // in the news/blog listing, since it has a redirect
    $(this).on('click', function() {
      var thisHref = $(this).data('pdfLink');
      ga('send', 'pageview', thisHref);
    })
  });

});

// GLOBAL SECTIONS

// Dropdown
$('.solutions-resources .dropdown > p').on('click', function () {
  var $parentDropdown = $(this).parent();
  $parentDropdown.toggleClass('open');
});

// News and Insights Carousel
var cardsContainer = document.querySelector('.cards-container');

if (cardsContainer) {
  new Glider(document.querySelector('.cards-container'), {
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: false,
    dots: '.dots',
    arrows: {
      prev: '.prev',
      next: '.next'
    },
    responsive: [
      {
        breakpoint: 920,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 760,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
    ]
  });
}

var Popup = (function () {
    var popup = document.getElementById('popup');
    var popupCloseBtn = document.getElementById('popup-close')

    var _position = function() {
        var popupHeight = popup.offsetHeight;
        var windowHeight = window.innerHeight || 0;
        var browserHeight = Math.max(document.documentElement.clientHeight, windowHeight);
        var pagePosition = document.documentElement.scrollTop || document.body.scrollTop;
        var popupTop = 10;

        if (popupHeight < browserHeight) {
            popupTop = browserHeight / 2 - popupHeight / 2;
        }

        popup.style.top = pagePosition + popupTop + 'px';
    }

    var _close = function () {
        popup.parentNode.removeChild(popup);
    };

    var _setupEvents = function () {
        popupCloseBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _close();
        });
    };

    var init = function () {
        if (!popup) {
            return;
        }

        _position();
        _setupEvents();
    };

    return {
        init: init
    }
})();

Popup.init()

// Promotional Slider
var $movingForwardSection = $(".moving-forward-section .promo-slides");
const $autoplay = $(".moving-forward-section").data("autoplay")

if ($movingForwardSection.length > 0) {
  function setArrowsColor($activeSlide) {
    $slideArrows = $('.moving-forward-section .slick-arrow');

    if ($activeSlide.hasClass('formatted-text')) {
      $slideArrows.addClass('dark');
      return;
    }

    $slideArrows.removeClass('dark');
  }

  $movingForwardSection.on('init', function(slick) {
    var $activeSlide = $('.moving-forward-section .slick-active');
    setArrowsColor($activeSlide);
  });

  $movingForwardSection.slick({
    adaptiveHeight: true,
    fade: true,
    autoplay: $autoplay,
    nextArrow: $(".promo-next"),
    prevArrow: $(".promo-prev")
  });

  $movingForwardSection.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    var $activeSlide = $('.moving-forward-section .slick-slide').eq(nextSlide);
    setArrowsColor($activeSlide);
  });
}


$(document).ready(function() {
  /*
   Solutions Dropdown (Used on Brand Protection Page)
  */

  // Open the the solutions dropdown based on the hash in the URL
  function openSolutionsDropdownByHash() {
    var $solutionsDropdown = $('.solutions-dropdown')

    if ($solutionsDropdown.length <= 0) {
      return
    }

    $solutionsDropdown.find('.dropdown').removeClass('open') // Close all drop downs

    var hash = window.top.location.hash.substr(1)

    if (!hash) {
      return
    }

    $solutionsDropdown.find('#' + hash).parent().addClass('open')
  }

  openSolutionsDropdownByHash()

  $(window).on('hashchange', function(e) {
    openSolutionsDropdownByHash()
  })
})

//Season Of Giving 2021 Carousel
$('.sog-carousel').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 5,
  variableWidth: true,
  prevArrow: $('.prev'),
  nextArrow: $('.next'),
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

// Update locale button text SOG 2021
if (
  $('#season-of-giving-2021').length > 0 ||
  $('#season-of-giving-2022').length > 0 ||
  $('#careers-landing-page').length > 0 ||
  $('#view-22').length > 0
) {
  var currentLocale = $('a[href="' + window.location.pathname + '"]').text()
  var $localButton = $('.locale-button')

  if ($localButton.hasClass('has-image')) {
    $('.locale-button span').text(currentLocale)
  } else {
    $('.locale-button').text(currentLocale)
  }
}

// View-22 Splide Carousel
$(document).ready(function() {
  function splideUpdateImages(logoSrc, arrowDownIconSrc, downloadIconSrc) {
    var $nav = $('#view-22 > nav')
    var $logo = $nav.find('.logo > img')
    var $arrowDownIcon = $nav.find('.icon-arrow-down')
    var $downloadIcon = $nav.find('.icon-download')

    $logo.attr('src', logoSrc)
    $arrowDownIcon.attr('src', arrowDownIconSrc)
    $downloadIcon.attr('src', downloadIconSrc)
  }

  function splideUpdateNavColor(newIndex, prevIndex, destIndex) {
    var hasDarkNav = destIndex !== 0 ? true : false
    var darkClass = 'dark'

    // Elements
    var $nav = $('#view-22 > nav')
    var $dots = $('#view-22 .splide-carousel')

    if (!hasDarkNav) {
      $nav.removeClass(darkClass)
      $dots.removeClass(darkClass)

      // Update images
      splideUpdateImages(
        '/assets/images/logos/logo-sedgwick-white.svg',
        '/assets/images/icons/arrow_down_white_2.svg',
        '/assets/images/icons/arrow-down-tail-white.svg'
      )

      return
    }

    $nav.addClass(darkClass)
    $dots.addClass(darkClass)

    // Update images
    splideUpdateImages(
      '/assets/images/logos/logo-sedgwick-dark.svg',
      '/assets/images/icons/arrow_down_dark.svg',
      '/assets/images/icons/arrow-down-tail-dark.png'
    )
  }

  function splideEvents(splide) {
    splide.on('move', splideUpdateNavColor)
  }

  function initializeSplide() {
    var $carousel = $('.splide-carousel')

    if ($carousel.length === 0) {
      return
    }

    var splide = new Splide('.splide-carousel', {
      arrows: false,
      direction: 'ttb',
      height: '100%',
      releaseWheel: true,
      pagination: false,
      speed: 1000,
      lazyLoad: true,
      updateOnMove: true,
      wheel: true,
      breakpoints: {
        768: {
          destroy: true,
        },
      }
    })

    splide.mount()

    // Events
    splideEvents(splide)
  }

  initializeSplide()
});

// View 22 open/close modal
$('.point-button').on('click', function(e) {
  $(this).next('.modal').toggleClass('open')
})

$('.point-close-button').on('click', function(e) {
  $(this).parents('.modal').removeClass('open')
})

// Dropdown Accessability
$('.locale-button').on('click', function() {
  var $button = $(this)
  var $dropdown = $button.siblings('#language-dropdown')

  $button.attr('aria-expanded', function (i, attr) {
    return attr == 'true' ? 'false' : 'true'
  })

  $dropdown.toggleClass('show')
})


// Careers page. Delay background display to after vidyard player loads
$(document).ready(function() {
  $('.one').delay(2500).fadeIn(400);
  $('.background').delay(2501).fadeIn(400);
})
